import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

/**
 * Styled metaform reply view container component
 */
export const ReplyViewContainer = styled(Stack, {
  label: "form-reply-container"
})(() => ({
  minHeight: "100%",
  width: "100%",
  backgroundColor: "#f7f8f7",
  overflow: "auto"
}));

/**
 * Styled metaform form reply content component
 */
export const FormReplyContent = styled(Box, {
  label: "form-reply-content"
})(() => ({
  width: "100%",
  boxSizing: "border-box"
}));

/**
 * Styled metaform form reply action component
 */
export const FormReplyAction = styled(Box, {
  label: "form-reply-action"
})(() => ({
  minHeight: 72,
  display: "flex",
  flexWrap: "wrap",
  gap: 12,
  backgroundColor: "#fff",
  alignItems: "center",
  padding: "14px 32px",
  borderBottom: "1px solid #e2e5e3",
  justifyContent: "space-between",
  "@media(max-width: 640px)": {
    alignItems: "stretch",
    padding: "12px 16px"
  }
}));